import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, Reorder } from 'framer-motion';
import './LeadDetails.css';
import {
    Phone, Mail, MapPin, ChevronLeft, MoreHorizontal, Filter, GitBranch,
    MessageSquare, Mic, Users, UserPlus, PhoneCall, LayoutGrid, Pencil,
    Trash2, X, Plus, Edit3, ChevronRight, Paperclip, Building2, Calendar, User,
    Copy, Printer, FileText, Check, Circle, ChevronUp, ChevronDown
} from 'lucide-react';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import Loader from '../../Loader/Loader';
import { getSession } from '../../../getSession';
import Enquiryoperations from '../../../pages/Enquiries/Enquiries/components/Enquiryoperations';

import Swal from 'sweetalert2';
import HubIcon from '@mui/icons-material/Hub';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import SmsIcon from '@mui/icons-material/Sms';
import GroupsIcon from '@mui/icons-material/Groups';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import CallWidget from '../CallWidget/CallWidget';

// Reusing constants from Enquiry LeadDetails
const MERGE_FIELDS = [
    { label: 'Name', key: 'PersonName' },
    { label: 'Mobile', key: 'MobileNo' },
    { label: 'Email', key: 'EmailId' },
    { label: 'Company', key: 'CompanyName' },
    { label: 'Address', key: 'Address' }
];

// const HARDCODED_OTHER_DETAILS = [
//     { "Text": "|Addendum|v", "Value": "1" },
//     { "Text": "|amount|v", "Value": "8844" },
//     { "Text": "|Bank_Name_okl|v", "Value": "8847" },
//     { "Text": "|Bank_Name_okl_2|v", "Value": "8868" },
//     { "Text": "|Bank_Name_okl_3|v", "Value": "3" },
//     { "Text": "|Bill_Amount|v", "Value": "8848" },
//     { "Text": "|Bill_Amount_2|v", "Value": "8869" },
//     { "Text": "|Bill_Amount_3|v", "Value": "4" },
//     { "Text": "|Business_Referral_Mandate|v", "Value": "5" },
//     { "Text": "|Card_Status|v", "Value": "8850" },
//     { "Text": "|Card_Status_2|v", "Value": "8871" },
//     { "Text": "|Card_Status_3|v", "Value": "6" },
//     { "Text": "|Card_Type|v", "Value": "8851" },
//     { "Text": "|Card_Type_2|v", "Value": "8872" },
//     { "Text": "|Card_Type_3|v", "Value": "7" },
//     { "Text": "|Centre_For_Education|v", "Value": "8" },
//     { "Text": "|Charges|v", "Value": "8846" },
//     { "Text": "|Client ID|v", "Value": "9" },
//     { "Text": "|Company_Incorporation_Date|v", "Value": "10" }
// ];
const NEW_ADDED_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const BACKEND_BASEURL_FOR_DEVELOPMENT = "https://dev3services.kit19.com/";
const LOCAL_BASE_URL = (process.env.REACT_APP_LOCAL_DEVELOPMENT_URL || '').replace(/\/$/, '');
const Get_EntityDeatils = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;
const WCF_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
const API_BASE1 = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const SERVICE_AZURE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
const SERVICE_KIT_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
const GetLeadDetailByLeadId = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.PIPELINE.GET_SCORECARD_DETAILS_NEW}`;
const Get_Custom_Fields_New = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_CUSTOM_FIELDS_NEW}`;
const Get_Custom_Fields_Mapping_New = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_LEAD_DETAILS_WITH_CUSTOM}`;
const webformDetails = `${NEW_ADDED_BASE_URL}/UserCRM/GetWebformDetailsByLeadId`;
const Pipeline_history = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_PIPELINE_HISTORY_BY_LEADID}`;
const Task_Appointment_History = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.TASKS.GET_TASK_HISTORY_FOR_DETAILS_EDIT}`;
const Follow_up = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_Follow_Up_DETAILS_FOR_LEADVIEW}`;
const For_Notes = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_NOTES_DETAILS_FOR_LEADVIEW}`;
const For_Document = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_DOCUMENT_DETAILS_FOR_LEADVIEW}`;
const Get_LeadDetails = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.TASKS.NEW_LEAD_ACTIVITY}`;
const Get_Chat_log = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_CHAT_LOGS}`;
const For_Wa_Chat_CONID = `${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_CON_ID}`;
//const GetWa_chat = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_W_CHAT}`;
const Get_call_logs = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_CALL_LOGS}`;
const Get_Past_meeting_bind = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_BIND_PAST_MEETING}`;
const Get_Upcoming_meeting_bind = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_BIND_UPCOMING_MEETING}`;
const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const SCORECARD_URL = `${NEWV3_BASE_URL}${API_ENDPOINTS.FOLLOWUPS.SCORE_CARD_DETAILS}`;
const Get_PipeLine_From_LeadID = `${API_BASE1}${API_ENDPOINTS.COMMON.GET_PIPELINE_FROM_LEADID}`;
const Pipeline_stage = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.PIPELINE_STAGE_BASED_ON_DEALPIPELINE}`;
const Get_Mapping_Status = `${API_BASE1}${API_ENDPOINTS.COMMON.GEP_MAPPING_STATUS}`;
const Get_Task_Appointment_History = `${API_BASE1}${API_ENDPOINTS.COMMON.GET_TASK_APPOINTMENT_HISTORY}`;
const Delete_Notes = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.DELETE_NOTES}`;
const Delete_Document = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.DELETE_DOCUMENT}`;
//const Get_Physical_Appointment_List = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.GET_PHYSICAL_APPOINTMENTLIST}`;
const GetWa_chat = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.GET_WA_CHAT_LOG}`;


const getInitials = (name) => {
    if (!name || name === 'N/A' || name === 'null') return '??';

    const trimmed = name.toString().trim();
    const digitsOnly = trimmed.replace(/\D/g, '');

    // Handle phone numbers or numeric IDs
    if (/^\+?\d+$/.test(trimmed) || (digitsOnly.length > 0 && digitsOnly.length === trimmed.replace(/\s/g, '').length)) {
        return digitsOnly.substring(0, 2);
    }

    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '??';

    if (parts.length === 1) {
        return parts[0][0].toUpperCase();
    }

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const generateAvatarColor = (str) => {
    if (!str || str === 'N/A') return '#475569';
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 65%, 45%)`; // Random color with consistent saturation/lightness
};

const getRelativeTime = (dateStr) => {
    if (!dateStr || dateStr === "N/A" || dateStr === "null") return "N/A";
    try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;

        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);

        if (diffInSeconds < 60) return "Just now";
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes}${diffInMinutes === 1 ? 'm' : 'm'} ago`; // Keep compact for minutes
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours}${diffInHours === 1 ? 'h' : 'h'} ago`; // Keep compact for hours
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 30) return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`;
        const diffInMonths = Math.floor(diffInDays / 30);
        if (diffInMonths < 12) return `${diffInMonths} ${diffInMonths === 1 ? 'month' : 'months'} ago`;
        const diffInYears = Math.floor(diffInMonths / 12);
        return `${diffInYears} ${diffInYears === 1 ? 'year' : 'years'} ago`;
    } catch (e) {
        return dateStr;
    }
};

const renderActivityDescription = (text) => {
    if (!text) return <span className="no-records">No detailed records found.</span>;

    // Pattern to match common labels followed by colon
    const labels = ['pipeline', 'Stage', 'Lead', 'Deal', 'Owner', 'Source', 'Status', 'Product'];

    // Split by comma followed by a known label to create multi-line effect
    const pattern = new RegExp(`,\\s*(?=${labels.join('|')}\\s*:)`, 'gi');
    const sections = text.split(pattern);

    return sections.map((section, idx) => {
        // Now bold the label in each section
        const innerPattern = new RegExp(`(${labels.join('|')})\\s*:`, 'gi');
        const parts = section.split(innerPattern);

        return (
            <div key={idx} className="desc-section" style={{ marginBottom: idx < sections.length - 1 ? '6px' : '0' }}>
                {parts.map((part, i) => {
                    const isLabel = labels.some(l => l.toLowerCase() === part.trim().toLowerCase());
                    if (isLabel) {
                        return <strong key={i} className="desc-label" style={{ color: '#1e293b', fontWeight: '700' }}>{part} :</strong>;
                    }
                    return <span key={i} className="desc-text">{part}</span>;
                })}
            </div>
        );
    });
};

const getDateUrgencyClass = (dateStr) => {
    if (!dateStr || dateStr === "N/A" || dateStr === "null") return "";
    try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const targetDate = new Date(date);
        targetDate.setHours(0, 0, 0, 0);

        const diffTime = targetDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays <= 0) return "date-overdue"; // Today or Overdue (Red)
        if (diffDays === 1) return "date-tomorrow"; // Tomorrow (Amber)
        if (diffDays <= 7) return "date-soon"; // Within a week (Blue)
        return "date-future"; // Beyond a week (Gray/Black)
    } catch (e) {
        return "";
    }
};

export const LeadDetails = ({ leadId, onBack, module = 'enquiry', initialScorecard, leadDetailsPerms, maskObject = (obj) => obj, isHiddenField = () => false }) => {
    const navigate = useNavigate();
    const isFollowupMode = module === 'followup' || module === 'task' || module === 'appointment' || module === 'physical_appointment' || module === 'quotation' || module === 'invoice' || module === 'pipeline_history' || module === 'activities';

    // Helper to get Icon and Class for Activity (Dynamic based on content)
    const ACTIVITY_ICON_BASE_URL = "https://kit19.com/assets/custom/UserCRMCampaign/Images/LeadActivityIMG/";

    const getActivityIconConfig = (act) => {
        const title = (act.EventTitle || act.ActivityTitle || act.EventName || "").toLowerCase();
        const desc = (act.EventDescription || act.ActivityDescription || "").toLowerCase();

        const customImg = act.LeadActivityIMG || act.ActivityImage || act.IconName;
        let iconName = "lifecycle.png"; // default

        if (customImg) {
            iconName = customImg.includes('.') ? customImg : `${customImg}.png`;
        } else {
            if (title.includes("whatsapp") || desc.includes("whatsapp")) iconName = "whatsapp.png";
            else if (title.includes("voice") || title.includes("call") || title.includes("ivr")) iconName = "voice_calls.png";
            else if (title.includes("sms") || title.includes("message")) iconName = "sms.png";
            else if (title.includes("meeting") || title.includes("appointment")) iconName = "appointment.png";
            else if (title.includes("task")) iconName = "task.png";
            else if (title.includes("webform")) iconName = "webform.png";
            else if (title.includes("lifecycle")) iconName = "lifecycle.png";
            else if (title.includes("support")) iconName = "support.png";
            else if (title.includes("notes")) iconName = "notes.png";
            else if (title.includes("email") || title.includes("mail")) iconName = "email.png";
        }

        const isWhatsapp = iconName.includes("whatsapp");
        const iconUrl = `${ACTIVITY_ICON_BASE_URL}${iconName}`;

        return {
            icon: (
                <img
                    src={iconUrl}
                    alt=""
                    className={isWhatsapp ? "whatsapp-icon-colored" : ""}
                    style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                    onError={(e) => { e.target.src = ACTIVITY_ICON_BASE_URL + "lifecycle.png" }}
                />
            ),
            className: isWhatsapp ? "icon-bg-whatsapp" : "icon-bg-default"
        };
    };

    // Core Data States
    const [basicInfo, setBasicInfo] = useState(null);
    const [scoreCard, setScoreCard] = useState(null);
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    // Tab states
    const [activeTab, setActiveTab] = useState(localStorage.getItem('LeadDetails_ActiveTab') || 'Chat Log');

    // History & Log states
    const [chatLogs, setChatLogs] = useState([]);
    const [waChatLogs, setWaChatLogs] = useState([]);
    const [callLogs, setCallLogs] = useState([]);
    const [pastMeetings, setPastMeetings] = useState([]);
    const [upcomingMeetings, setUpcomingMeetings] = useState([]);
    const [webforms, setWebforms] = useState([]);
    const [followupDetails, setFollowupDetails] = useState([]);
    const [physicalAppointments, setPhysicalAppointments] = useState([]);
    const [notes, setNotes] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [taskHistory, setTaskHistory] = useState([]);
    const [appointmentHistory, setAppointmentHistory] = useState([]);
    const [webformData, setWebformData] = useState([]);
    const [pipelineHistory, setPipelineHistory] = useState([]);
    const [pipelineStages, setPipelineStages] = useState([]);
    const [activePipeline, setActivePipeline] = useState(null);
    const [mappingStatuses, setMappingStatuses] = useState({});
    
    // Multiple Pipelines Support
    const [allPipelines, setAllPipelines] = useState([]);
    const [showAllPipelines, setShowAllPipelines] = useState(false);

    // Extra Data for Enquiry
    const [enquiryDetailData, setEnquiryDetailData] = useState([]);
    const [customDetailMoreData, setCustomDetailMoreData] = useState([]);

    // UI States
    const [activeSidebarAction, setActiveSidebarAction] = useState(null);
    const [tabOrder, setTabOrder] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isLogLoading, setIsLogLoading] = useState(false);
    const [isScheduleCallOpen, setIsScheduleCallOpen] = useState(false);
    const [isFullDetailsOpen, setIsFullDetailsOpen] = useState(false);
    const [showWebformModal, setShowWebformModal] = useState(false);
    const [selectedWebformData, setSelectedWebformData] = useState(null);
    const [taskSort, setTaskSort] = useState('newest');
    const [apptSort, setApptSort] = useState('newest');

    // Click to Call Widget State
    const [showCallWidget, setShowCallWidget] = useState(false);
    const [callingLead, setCallingLead] = useState(null);
    const [callTriggerRect, setCallTriggerRect] = useState(null);


    // Context/Session
    const { TokenId: TOKEN, userId: LOGGED_USER_ID, parentId: PARENT_ID } = getSession();

    // API Helpers
    const safeParse = (data) => {
        if (!data) return null;
        if (typeof data === 'object') return data;
        try { return JSON.parse(data); } catch (e) { return data; }
    };

    const fetchInitialData = async () => {
        if (!leadId) return;
        setLoading(true);
        try {
            const leadIdNum = Number(leadId);
            const WCF_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');


            const promises = [];
            if (initialScorecard) {
                setScoreCard(initialScorecard);
            } else {
                promises.push(
                    fetch(SCORECARD_URL, {
                        method: 'POST',
                        headers: { "Content-Type": "application/json; charset=UTF-8" },
                        body: JSON.stringify({ Token: "-2295521862261168", Details: { EnquiryID: leadId.toString() } })
                    }).then(r => r.json()).then(res => ({ d: res.Details || res.d })).catch(() => null)
                );
            }

            // Use the correct URL (Get_EntityDeatils = v3.services.kit19.com/UserCRM/GetLeadDetailByLeadId)
            // with the exact payload the API expects
            promises.push(
                fetch(Get_EntityDeatils, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        Token: TOKEN || API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN,
                        Message: "",
                        LoggedUserId: LOGGED_USER_ID || localStorage.getItem('userId') || '34594',
                        MAC_Address: "",
                        IP_Address: "",
                        BroadcastName: "",
                        Details: { LeadId: leadIdNum }
                    })
                }).then(r => r.json()).catch(() => null)
            );

            const results = await Promise.all(promises);

            let leadDetailData;
            if (initialScorecard) {
                leadDetailData = results[0];
            } else {
                const scoreData = results[0];
                if (scoreData) {
                    const sd = scoreData.d || scoreData;
                    setScoreCard(Array.isArray(sd) ? sd : (sd?.Table || sd));
                }
                leadDetailData = results[1];
            }

            if (leadDetailData) {
                const parsed = safeParse(leadDetailData);
                // Details is a JSON string in the API response — parse it
                let detailsArr = parsed?.Details;
                if (typeof detailsArr === 'string') {
                    try { detailsArr = JSON.parse(detailsArr); } catch (e) { detailsArr = null; }
                }
                const basic = (Array.isArray(detailsArr) ? detailsArr[0] : null)
                    || (detailsArr && !Array.isArray(detailsArr) ? detailsArr : null)
                    || parsed?.Table?.[0]
                    || parsed?.Data?.[0]
                    || (Array.isArray(parsed) ? parsed[0] : null)
                    || {};
                console.log('[LeadDetails] basicInfo set:', basic);
                setBasicInfo(basic);
            }

            // Fetch Activities by default
            fetchActivities(leadId);

            // Fetch Pipeline and Stages
            fetchPipelineAndStages(leadId);

            // Fetch Dynamic Custom Fields
            fetchDynamicCustomFields(leadId);

        } catch (error) {
            console.error("Error fetching lead data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPipelineAndStages = async (id) => {
        try {
            const token = TOKEN || localStorage.getItem('TokenId') || "-2295521862261168";

            // 1. Get Pipeline for Lead
            const pRes = await fetch(Get_PipeLine_From_LeadID, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: token,
                    Details: { LeadId: id.toString() }
                })
            });
            const pData = await pRes.json();
            const pipelinesRaw = pData.Details || pData.d || [];
            const pipelinesArray = Array.isArray(pipelinesRaw) ? pipelinesRaw : (pipelinesRaw.Table ? pipelinesRaw.Table : (pipelinesRaw ? [pipelinesRaw] : []));
            const activeP = pipelinesArray.length > 0 ? pipelinesArray[0] : null;

            if (activeP && activeP.PipeLineID) {
                setActivePipeline(activeP);
                
                const loadedPipelines = [];
                for (const pipeline of pipelinesArray) {
                    if (!pipeline || !pipeline.PipeLineID) continue;
                    
                    const sRes = await fetch(Pipeline_stage, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ Token: token, Details: parseInt(pipeline.PipeLineID, 10), Message: "", Status: "" })
                    });
                    const sData = await sRes.json();
                    const stagesList = sData.Details || sData.d || [];

                    const statuses = {};
                    await Promise.all(stagesList.map(async (stage) => {
                        try {
                            const mRes = await fetch(Get_Mapping_Status, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ Token: token, Details: { StageID: String(stage.Id), LeadID: String(id) } })
                            });
                            const mData = await mRes.json();
                            if (mData.Details && mData.Details.length > 0) {
                                statuses[stage.Id] = mData.Details[0];
                            }
                        } catch (e) { console.error("Error mapping status:", e); }
                    }));
                    
                    loadedPipelines.push({ pipeline, stages: stagesList, statuses });
                }
                
                setAllPipelines(loadedPipelines);
                
                // Keep backward compatibility for single pipeline accesses
                if (loadedPipelines.length > 0) {
                    setPipelineStages(loadedPipelines[0].stages);
                    setMappingStatuses(loadedPipelines[0].statuses);
                }
            }
        } catch (e) {
            console.error("Error fetching pipeline stages:", e);
        }
    };


    const fetchActivities = async (id) => {
        try {
            setIsLogLoading(true);
            const endpoint = "https://services.kit19.com/UserCRM/GetLeadActivity";

            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                Message: "",
                LoggedUserId: LOGGED_USER_ID ? parseInt(LOGGED_USER_ID, 10) : 0,
                MAC_Address: "",
                IP_Address: "",
                BroadcastName: "",
                Details: {
                    LeadID: parseInt(id, 10),
                    Start: 0,
                    Limit: 10
                }
            };

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                let list = (result.Details || result.d || result.data || []);

                // If it's a string, try to parse it (common in some legacy APIs)
                if (typeof list === 'string') {
                    try { list = JSON.parse(list); } catch (e) { list = []; }
                }

                // If it's an object with Table/Data instead of an array
                if (list && !Array.isArray(list)) {
                    list = list.Table || list.Data || [list];
                }

                // Normalize fields for the timeline UI
                const normalizedList = Array.isArray(list) ? list.map(act => ({
                    ...act,
                    // Use EventName/Type if present, otherwise fallback to FollowupStatus
                    EventName: act.EventName || act.ActivityType || act.FollowupStatus || 'Activity',
                    // Use EventDescription/Description if present, otherwise fallback to Remarks
                    EventDescription: act.EventDescription || act.Description || act.Remarks || '',
                    // Use EventDate/ActivityDate if present, otherwise fallback to NextStatusDate or CreatedDate
                    EventDate: act.EventDate || act.ActivityDate || act.NextStatusDate || act.CreatedDate || act.StatusDate || ''
                })) : [];

                setActivities(normalizedList);
            }
        } catch (e) { console.error("Error fetching activities", e); }
        finally { setIsLogLoading(false); }
    };

    const fetchDynamicCustomFields = async (id) => {
        try {
            const token = TOKEN || localStorage.getItem('TokenId') || "-2295521862261168";
            const userId = LOGGED_USER_ID || localStorage.getItem('userId') || "34594";
            const parentId = PARENT_ID || localStorage.getItem('parentId') || userId;

            // 1. Fetch Custom Field Definitions
            const defRes = await fetch(Get_Custom_Fields_New, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: token,
                    Message: "",
                    LoggedUserId: parseInt(userId, 10),
                    MAC_Address: "",
                    IP_Address: "",
                    Details: { ParentId: parseInt(parentId, 10) }
                })
            });
            const defData = await defRes.json();
            const fields = defData.Details || (defData.d && defData.d.Details) || [];

            // 2. Fetch Mapping Values for this Lead
            const mapRes = await fetch(Get_Custom_Fields_Mapping_New, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: token,
                    Details: JSON.stringify({
                        draw: 1,
                        StartNo: 0,
                        EndNo: 1,
                        UserId: parseInt(userId, 10),
                        ParentId: parseInt(parentId, 10),
                        FilterText: "ID=" + id
                    })
                })
            });
            const mapData = await mapRes.json();

            let mappingRow = null;
            const mappingDetails = mapData.Details || (mapData.d && mapData.d.Details) || mapData.d;
            if (mappingDetails) {
                const parsedDetails = safeParse(mappingDetails);
                mappingRow = (Array.isArray(parsedDetails) ? parsedDetails[0] : null)
                    || (parsedDetails && !Array.isArray(parsedDetails) ? (parsedDetails.Table?.[0] || parsedDetails.Data?.[0] || parsedDetails) : null);
            }

            console.log('[LeadDetails] Dynamic Fields:', fields);
            console.log('[LeadDetails] Mapping Row:', mappingRow);

            if (fields && fields.length > 0) {
                const transformed = fields.map(f => {
                    // Try to get value from mappingRow using FieldName
                    const val = mappingRow ? (mappingRow[f.FieldName] || mappingRow[f.FieldName.toLowerCase()] || mappingRow[f.FieldName.replace(/\s/g, '_')] || "") : "";
                    return {
                        Text: `v${val}|${f.FieldName}|v`,
                        Value: String(f.FieldId)
                    };
                });
                setEnquiryDetailData(transformed);
            }
        } catch (e) {
            console.error("Error fetching dynamic custom fields:", e);
        }
    };



    useEffect(() => {
        if (!leadId) return;
        const storageKey = `LeadDetails_ActiveTab_${LOGGED_USER_ID || 'user'}`;
        const savedTab = localStorage.getItem(storageKey);
        if (savedTab) setActiveTab(savedTab);
    }, [leadId, LOGGED_USER_ID]);

    useEffect(() => {
        if (!leadId) return;
        fetchInitialData();

        // Initialize Tab Order from localStorage (per lead + per user) or default
        const uid = LOGGED_USER_ID || 'user';
        const storageKey = `LeadDetails_Tabs_${uid}_${isFollowupMode ? 'followup' : 'lead'}_${leadId}`;
        const savedOrder = localStorage.getItem(storageKey);

        if (savedOrder) {
            try {
                setTabOrder(JSON.parse(savedOrder));
            } catch (e) {
                const initialTabs = isFollowupMode
                    ? ['Chat Log', 'Activities', 'Followup Details', 'Notes', 'Documents', 'Task', 'Appointment', 'Webform', 'Pipeline', 'WaChat Log', 'Call Log', 'Meetings']
                    : ['Chat Log', 'Activities', 'Calls', 'Whatsapp Chat Log', 'Meetings', 'Physical Appointment', 'Webform'];
                setTabOrder(initialTabs);
            }
        } else {
            const initialTabs = isFollowupMode
                ? ['Chat Log', 'Activities', 'Followup Details', 'Notes', 'Documents', 'Task', 'Appointment', 'Webform', 'Pipeline', 'WaChat Log', 'Call Log', 'Meetings']
                : ['Chat Log', 'Activities', 'Calls', 'Whatsapp Chat Log', 'Meetings', 'Physical Appointment', 'Webform'];
            setTabOrder(initialTabs);
        }
    }, [leadId, isFollowupMode, LOGGED_USER_ID]);

    // Tab Data Loading
    useEffect(() => {
        if (!leadId || loading) return;
        // Logic to fetch tab-specific data when activeTab changes
        if (activeTab === 'Followup Details' && isFollowupMode) fetchFollowupDetails(leadId);
        if (activeTab === 'Notes') fetchNotes(leadId);
        if (activeTab === 'Documents') fetchDocuments(leadId);
        if (activeTab === 'Task') fetchTaskHistory(leadId);
        if (activeTab === 'Appointment') fetchAppointmentHistory(leadId);
        if (activeTab === 'Chat Log') fetchChatLogs(leadId);
        if (activeTab === 'Webform') fetchWebforms(leadId);
        if (activeTab === 'Pipeline') fetchPipelineHistory(leadId);
        if (activeTab === 'WaChat Log' || activeTab === 'Whatsapp Chat Log') fetchWaChatLogs(leadId);
        if (activeTab === 'Call Log') fetchCallLogs(leadId);
        if (activeTab === 'Meetings') {
            fetchUpcomingMeetings(leadId);
            fetchPastMeetings(leadId);
        }
    }, [activeTab, leadId, loading]);

    const fetchFollowupDetails = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                LoggedUserId: LOGGED_USER_ID || localStorage.getItem('userId') || "34594",
                Details: {
                    LeadId: parseInt(id, 10),
                    timeZone: "India Standard Time"
                }
            };

            const response = await fetch(Follow_up, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setFollowupDetails(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchNotes = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: localStorage.getItem('TokenId') || "-2295521862261168",
                LoggedUserId: LOGGED_USER_ID || localStorage.getItem('userId') || "34594",
                Details: { LeadId: parseInt(id, 10), timeZone: "India Standard Time" }
            };
            const response = await fetch(For_Notes, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setNotes(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const handleDeleteNote = async (noteId) => {
        if (leadDetailsPerms && !leadDetailsPerms.Delete) {
            Swal.fire('Access Denied', "You don't have permission to delete notes.", 'warning');
            return;
        }
        const confirmDelete = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to delete this note permanently!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3b82f6',
            cancelButtonColor: '#ef4444',
            confirmButtonText: 'Yes, delete it!'
        });

        if (!confirmDelete.isConfirmed) return;

        try {
            setIsLogLoading(true);
            const token = localStorage.getItem('TokenId') || "-2295521862261168";
            const userId = localStorage.getItem('UserId') || LOGGED_USER_ID || "34594";

            const payload = {
                Token: token,
                Details: {
                    noteid: noteId,
                    UserId: userId
                }
            };

            const response = await fetch(Delete_Notes, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            if (response.ok && (data.Status === 1 || data.d?.Status === 1)) {
                Swal.fire({
                    title: 'Deleted!',
                    text: 'Note deleted successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                fetchNotes(leadId);
            } else {
                Swal.fire('Error', data.Message || "Failed to delete note", 'error');
            }
        } catch (error) {
            console.error("Error deleting note:", error);
            Swal.fire('Error', 'An error occurred while deleting the note.', 'error');
        } finally {
            setIsLogLoading(false);
        }
    };

    const handleDeleteDocument = async (docId) => {
        if (leadDetailsPerms && !leadDetailsPerms.Delete) {
            Swal.fire('Access Denied', "You don't have permission to delete documents.", 'warning');
            return;
        }
        const confirmDelete = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to delete this document permanently!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3b82f6',
            cancelButtonColor: '#ef4444',
            confirmButtonText: 'Yes, delete it!'
        });

        if (!confirmDelete.isConfirmed) return;

        try {
            setIsLogLoading(true);
            const token = localStorage.getItem('TokenId') || "-2295521862261168";
            const userId = localStorage.getItem('UserId') || LOGGED_USER_ID || "34594";

            const payload = {
                Token: token,
                Details: {
                    DocUpID: docId,
                    UserId: userId
                }
            };

            const response = await fetch(Delete_Document, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            if (response.ok && (data.Status === 1 || data.d?.Status === 1)) {
                Swal.fire({
                    title: 'Deleted!',
                    text: 'Document deleted successfully',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
                fetchDocuments(leadId);
            } else {
                Swal.fire('Error', data.Message || "Failed to delete document", 'error');
            }
        } catch (error) {
            console.error("Error deleting document:", error);
            Swal.fire('Error', 'An error occurred while deleting the document.', 'error');
        } finally {
            setIsLogLoading(false);
        }
    };

    const fetchDocuments = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                LoggedUserId: LOGGED_USER_ID || localStorage.getItem('userId') || "34594",
                Details: { LeadId: parseInt(id, 10), timeZone: "India Standard Time" }
            };
            const response = await fetch(For_Document, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setDocuments(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchTaskHistory = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                Message: "",
                LoggedUserId: LOGGED_USER_ID ? parseInt(LOGGED_USER_ID, 10) : 34594,
                MAC_Address: "",
                IP_Address: "",
                BroadcastName: "",
                Details: {
                    FilterText: " AND LeadId = " + id + " ",
                    UserId: LOGGED_USER_ID ? parseInt(LOGGED_USER_ID, 10) : 34594,
                    Mode: "T",
                    OffsetValue: 0,
                    PagingSize: 3000,
                    CriteriaName: ""
                }
            };
            const response = await fetch(Task_Appointment_History, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                const history = (data.Details || data.d || []).map(item => ({
                    ...item,
                    Collaborators: item.Collaborators || item.Collaboraters
                }));
                setTaskHistory(history);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchAppointmentHistory = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                Message: "",
                LoggedUserId: LOGGED_USER_ID ? parseInt(LOGGED_USER_ID, 10) : 34594,
                MAC_Address: "",
                IP_Address: "",
                BroadcastName: "",
                Details: {
                    FilterText: " AND LeadId = " + id + " ",
                    UserId: LOGGED_USER_ID ? parseInt(LOGGED_USER_ID, 10) : 34594,
                    Mode: "A",
                    OffsetValue: 0,
                    PagingSize: 3000,
                    CriteriaName: ""
                }
            };
            const response = await fetch(Task_Appointment_History, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                const history = (data.Details || data.d || []).map(item => ({
                    ...item,
                    Collaborators: item.Collaborators || item.Collaboraters
                }));
                setAppointmentHistory(history);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchChatLogs = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                Details: { LeadId: parseInt(id, 10) }
            };
            const response = await fetch(Get_Chat_log, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setChatLogs(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchWebforms = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    LeadId: parseInt(id, 10)
                }
            };
            const response = await fetch(webformDetails, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setWebformData(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchPipelineHistory = async (id) => {
        try {
            setIsLogLoading(true);
            const token = localStorage.getItem('TokenId') || "-2295521862261168";
            const response = await fetch(Pipeline_history, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: token,
                    Details: { leadId: parseInt(id, 10) }
                })
            });
            if (response.ok) {
                const data = await response.json();
                setPipelineHistory(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchWaChatLogs = async (id) => {
        try {
            setIsLogLoading(true);
            const tokenValue = localStorage.getItem('TokenId') || "-2295521862261168";
            const userIdValue = localStorage.getItem('userId') || "34594";

            // Step 1: Get ConversationId
            const conIdRes = await fetch(For_Wa_Chat_CONID, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ EntityID: String(id), EntityName: "lead" })
            });

            if (!conIdRes.ok) return;
            const conData = await conIdRes.json();
            const conversationId = conData.d || conData.ConversationId;

            if (!conversationId) return;

            // Step 2: Get WhatsApp Chats
            const payload = {
                Token: tokenValue,
                Details: {
                    UserId: parseInt(userIdValue, 10),
                    EntityId: String(id),
                    EntityName: "Lead",
                    ConversationId: parseInt(conversationId, 10),
                    LeadActivityId: 0,
                    Direction: "inbound"
                }
            };

            const response = await fetch(GetWa_chat, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json();
                setWaChatLogs(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchCallLogs = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                Details: {
                    EntityName: "Lead",
                    EntityID: String(id),
                    Start: "0",
                    Limit: "10"
                }
            };
            const response = await fetch(Get_call_logs, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setCallLogs(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchUpcomingMeetings = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                Details: { EntityId: String(id), UserId: LOGGED_USER_ID ? parseInt(LOGGED_USER_ID, 10) : 34594 }
            };
            const response = await fetch(Get_Upcoming_meeting_bind, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setUpcomingMeetings(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const fetchPastMeetings = async (id) => {
        try {
            setIsLogLoading(true);
            const payload = {
                Token: TOKEN || localStorage.getItem('TokenId') || "-2295521862261168",
                Details: { EntityId: String(id), UserId: LOGGED_USER_ID ? parseInt(LOGGED_USER_ID, 10) : 34594 }
            };
            const response = await fetch(Get_Past_meeting_bind, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                setPastMeetings(data.Details || data.d || []);
            }
        } catch (e) { console.error(e); } finally { setIsLogLoading(false); }
    };

    const handleCallClick = (e, number, leadData = null) => {
        e.stopPropagation();
        if (!number || number === 'N/A') return;

        const rect = e.currentTarget.getBoundingClientRect();
        setCallTriggerRect(rect);

        // Prepare lead data for widget
        const callData = leadData || {
            PersonName: lead.PersonName,
            MobileNo: number,
            LeadId: leadId
        };

        setCallingLead(callData);
        setShowCallWidget(true);
    };

    if (loading) return <div className="lead-details-view loading"><Loader /></div>;

    const formatDisplayDate = (dateStr) => {
        if (!dateStr || dateStr === "N/A" || dateStr === "null" || dateStr === "0") return '';
        const cleanStr = String(dateStr).trim();
        let date = new Date(cleanStr);

        if (isNaN(date.getTime())) {
            const monthsMap = { 'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5, 'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11 };
            const parts = cleanStr.split(/[- .:]/);
            if (parts.length >= 3) {
                if (monthsMap[parts[1]] !== undefined) {
                    date = new Date(parts[2], monthsMap[parts[1]], parts[0]);
                } else if (!isNaN(parts[1]) && parts[0].length === 2) {
                    date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                }
            }
        }

        if (isNaN(date.getTime())) return dateStr;

        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const d = String(date.getDate()).padStart(2, '0');
        const m = months[date.getMonth()];
        const y = date.getFullYear();

        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${d}-${m}-${y} ${hh}:${mm}:${ss}`;
    };

    const leadRec = basicInfo || {};
    const scoreRec = (Array.isArray(scoreCard) && scoreCard.length > 0 ? scoreCard[0] : (scoreCard?.Table?.[0] || {}));

    const rawLead = {
        PersonName: leadRec.personname || scoreRec.PersonName || '',
        MobileNo: leadRec.mobileno || leadRec.phones || leadRec.Mobile || scoreRec.MobileNo || '',
        EmailId: leadRec.emailid || leadRec.emails || leadRec.Email || scoreRec.EmailId || '',
        StateName: leadRec.state || scoreRec.StateName || '',
        CurrentScore: scoreRec.CurrentScore || '0',
        LeadNo: leadRec.leadno || leadRec.LeadId || scoreRec.LeadNo || '',
        CompanyName: leadRec.companyname || scoreRec.CompanyName || '',
        City: leadRec.city || scoreRec.City || '',
        Country: leadRec.country || '',
        AssignedTo: leadRec.assigned_to || leadRec.assign_id || scoreRec.AssignedTo || '',
        FollowupStatus: leadRec.followupstatus || scoreRec.FollowupStatus || '',
        FollowupDate: formatDisplayDate(leadRec.followupdate || ''),
        Remark: leadRec.remark || '',
        Groups: leadRec.groups || '',
        Source: leadRec.source || scoreRec.Source || '',
        Medium: leadRec.medium || scoreRec.Medium || '',
        Campaign: leadRec.campaignname || scoreRec.CampaignName || '',
        Address: leadRec.Address || leadRec.residentialaddress || leadRec.officeaddress || scoreRec.FullAddress || '',
        CreatedOn: formatDisplayDate(leadRec.createdon || scoreRec.CreatedOn || ''),
        ModifiedOn: formatDisplayDate(leadRec.modifiedon || ''),
        CreatedBy: leadRec.createdby || '',
        ModifiedBy: leadRec.modifiedby || '',
    };
    const lead = maskObject(rawLead);

    const handlePrintWebform = (data) => {
        if (!data) return;
        const formName = data.FormName || data.formName || 'Webform Details';
        const rawData = data.FormData || data.formData || data.DynimicAttr || data.dynimicAttr || '';
        let fieldsHtml = '';

        try {
            const parsed = typeof rawData === 'string' && (rawData.trim().startsWith('{') || rawData.trim().startsWith('['))
                ? JSON.parse(rawData)
                : (typeof rawData === 'object' ? rawData : null);

            if (parsed && typeof parsed === 'object') {
                fieldsHtml = Object.entries(parsed).map(([key, value]) => `
                    <div class="field-row">
                        <span class="field-key">${key}:</span>
                        <span class="field-value">${value || '-'}</span>
                    </div>
                `).join('');
            } else {
                fieldsHtml = `<div style="padding: 20px;">${rawData}</div>`;
            }
        } catch (e) {
            fieldsHtml = `<div style="padding: 20px;">${rawData}</div>`;
        }

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>${formName}</title>
                    <style>
                        body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; padding: 40px; color: #0f172a; line-height: 1.5; }
                        h1 { font-size: 24px; font-weight: 700; color: #0f172a; border-bottom: 2px solid #e2e8f0; padding-bottom: 15px; margin-bottom: 25px; }
                        .field-row { display: flex; padding: 12px; border-bottom: 1px solid #f1f5f9; }
                        .field-row:nth-child(even) { background: #f8fafc; }
                        .field-key { min-width: 180px; font-weight: 700; color: #475569; }
                        .field-value { color: #1e293b; }
                        .container { border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden; }
                        .footer { margin-top: 50px; font-size: 11px; color: #94a3b8; border-top: 1px solid #f1f5f9; padding-top: 15px; display: flex; justify-content: space-between; }
                        /* Modern Chips Pipeline Design */
                        .modern-chips-pipeline-container {
                            background: #f8fafc;
                            border-radius: 8px;
                            padding: 12px 16px;
                            margin: 10px 15px 5px 15px;
                            border: 1px solid #f1f5f9;
                        }

                        .modern-chips-pipeline-container .pipeline-meta {
                            margin-bottom: 12px;
                        }

                        .modern-chips-pipeline-container .pipeline-title-text {
                            font-size: 12px;
                            font-weight: 700;
                            color: #475569;
                            text-transform: uppercase;
                            letter-spacing: 0.05em;
                        }

                        .chips-pipeline-scroll-area {
                            width: 100%;
                            overflow-x: auto;
                            scrollbar-width: none;
                            -ms-overflow-style: none;
                            padding-bottom: 4px;
                        }

                        .chips-pipeline-scroll-area::-webkit-scrollbar {
                            display: none;
                        }

                        .chips-pipeline-track {
                            display: flex;
                            align-items: flex-start;
                            gap: 12px;
                            min-width: max-content;
                        }

                        .chip-item-container {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            gap: 6px;
                        }

                        .pipeline-chip {
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            padding: 6px 12px;
                            border-radius: 20px;
                            font-size: 12px;
                            font-weight: 600;
                            transition: all 0.3s ease;
                            cursor: default;
                            border: 1px solid transparent;
                        }

                        .pipeline-chip.completed {
                            background: #e0f2fe;
                            color: #0284c7;
                            border-color: #bae6fd;
                        }

                        .pipeline-chip.active {
                            background: #ffffff;
                            color: #0ea5e9;
                            border-color: #0ea5e9;
                            box-shadow: 0 4px 6px -1px rgba(14, 165, 233, 0.1), 0 2px 4px -1px rgba(14, 165, 233, 0.06);
                            transform: scale(1.02);
                        }

                        .pipeline-chip.future {
                            background: #ffffff;
                            color: #94a3b8;
                            border-color: #e2e8f0;
                        }

                        .chip-icon {
                            flex-shrink: 0;
                        }

                        .chip-pulse-dot {
                            width: 8px;
                            height: 8px;
                            background: #0ea5e9;
                            border-radius: 50%;
                            animation: chip-pulse 2s infinite;
                        }

                        @keyframes chip-pulse {
                            0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(14, 165, 233, 0.7); }
                            70% { transform: scale(1); box-shadow: 0 0 0 4px rgba(14, 165, 233, 0); }
                            100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(14, 165, 233, 0); }
                        }

                        .chip-name {
                            white-space: nowrap;
                        }

                        .chip-date {
                            font-size: 10px;
                            color: #64748b;
                            font-weight: 500;
                        }
                        @media print {
                            body { padding: 20px; }
                            .container { border-color: #eee; }
                        }
                    </style>
                </head>
                <body>
                    <h1>${formName}</h1>
                    <div class="container">
                        ${fieldsHtml}
                    </div>
                    <div class="footer">
                        <span>Printed from CRM</span>
                        <span>${new Date().toLocaleString()}</span>
                    </div>
                    <script>
                        window.onload = function() {
                            setTimeout(() => {
                                window.print();
                            }, 500);
                        };
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    };

    const handleCopyWebform = (data) => {
        if (!data) return;
        const rawData = data.FormData || data.formData || data.DynimicAttr || data.dynimicAttr || '';
        let text = '';

        try {
            const parsed = typeof rawData === 'string' && (rawData.trim().startsWith('{') || rawData.trim().startsWith('['))
                ? JSON.parse(rawData)
                : (typeof rawData === 'object' ? rawData : null);

            if (parsed && typeof parsed === 'object') {
                text = Object.entries(parsed).map(([key, value]) => `${key}: ${value}`).join('\n');
            } else {
                text = rawData;
            }
        } catch (e) {
            text = rawData;
        }

        navigator.clipboard.writeText(text).then(() => {
            // Success
        });
    };

    if (leadDetailsPerms && leadDetailsPerms.View === false) {
        return (
            <div className="lead-details-overlay">
                <div className="lead-details-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', backgroundColor: '#f8fafc', padding: '40px' }}>
                    <div style={{ background: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '400px' }}>
                        <div style={{ width: '64px', height: '64px', background: '#fee2e2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                            <X size={32} color="#ef4444" />
                        </div>
                        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b', marginBottom: '16px' }}>Access Denied</h2>
                        <p style={{ color: '#64748b', marginBottom: '32px', lineHeight: '1.5' }}>
                            You do not have permission to view Lead Details. Please contact your administrator if you believe this is a mistake.
                        </p>
                        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                            <button 
                                onClick={() => navigate('/dashboard')}
                                style={{ padding: '10px 20px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '500', transition: 'background 0.2s' }}
                                onMouseOver={(e) => e.target.style.background = '#e2e8f0'}
                                onMouseOut={(e) => e.target.style.background = '#f1f5f9'}
                            >
                                Dashboard
                            </button>
                            <button 
                                onClick={() => {
                                    localStorage.clear();
                                    navigate('/');
                                }}
                                style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '500', transition: 'background 0.2s' }}
                                onMouseOver={(e) => e.target.style.background = '#2563eb'}
                                onMouseOut={(e) => e.target.style.background = '#3b82f6'}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`lead-details-view module-${module}`}>
            <div className="lead-details-header-wrapper">
                <button className="back-btn-v2" onClick={onBack}>
                    <ChevronLeft size={18} /> Back to {
                        module === 'task' ? 'Task' :
                            module === 'appointment' ? 'Appointment' :
                                module === 'physical_appointment' ? 'Physical Appointment' :
                                    module === 'followup' ? 'Follow-Up' :
                                        module === 'quotation' ? 'Quotation' :
                                            module === 'invoice' ? 'Invoice' :
                                                module === 'pipeline_history' ? 'Pipeline History' :
                                                    module === 'conversion' ? 'Conversion' :
                                                        module === 'activities' ? 'Lead Activity' : 'Enquiry'
                    }
                </button>
                <div className="main-header-content">
                    <div className="header-actions-v2">
                        {/* Header actions can go here if needed later */}
                    </div>
                </div>
            </div>

            <div className="lead-details-content-wrapper">
                <div className="lead-details-main-content">
                    {/* Basic Details Section */}
                    <div className="details-section shadow-sm">
                        <div className="section-header">Basic Details</div>
                        <div className="section-body">
                            <div className="lead-info-main">
                                <div className="lead-header-row-v2">
                                    <div className="name-mobile-col">
                                        <div className="lead-avatar-big">
                                            <div className="avatar-circle">
                                                {(() => {
                                                    const initials = getInitials(lead.PersonName);
                                                    return (
                                                        <div
                                                            className="avatar-initials"
                                                            style={{
                                                                color: generateAvatarColor(lead.PersonName),
                                                                fontSize: initials.length > 1 ? '20px' : '24px',
                                                                letterSpacing: initials.length > 1 ? '-1px' : 'normal'
                                                            }}
                                                        >
                                                            {initials}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                            <div className="score-badge-wrapper">
                                                <span className="score-badge">{lead.CurrentScore || '0'}</span>
                                            </div>
                                            <div className="scorecard-hover-popup">
                                                <div className="scorecard-white-card">
                                                    <div className="scorecard-header">
                                                        <h4 className="scorecard-mobile contact-link" onClick={(e) => handleCallClick(e, lead.MobileNo)}>
                                                            {lead.MobileNo}
                                                        </h4>
                                                        <p className="scorecard-since">Lead since {scoreRec.CreatedOn || lead.CreatedOn || 'N/A'}</p>
                                                    </div>
                                                    <div className="scorecard-summary-row">
                                                        <span className="summary-text">
                                                            Lead score <span className={`score-trend ${(scoreRec.Profit_Loss || '').includes('Green') ? 'up' : 'down'}`}>
                                                                {(scoreRec.Profit_Loss || '').includes('Green') ? '▲' : '▼'}{scoreRec.ScorePRCNTG || '0'}%
                                                            </span> in last 7 days. Top scoring factor(s):
                                                        </span>
                                                    </div>
                                                    <div className="scorecard-body">
                                                        <div className="score-circle-large-v2">
                                                            <span className="score-val-v2">{lead.CurrentScore || '0'}</span>
                                                        </div>
                                                        <div className="score-factors-v-list">
                                                            {(scoreRec.Top3ScoringFactors || "").split('#').filter(f => f).map((factor, i) => (
                                                                <div key={i} className="score-factor-row">
                                                                    <span className="factor-arrow">▲</span>
                                                                    <span className="factor-desc">{factor}</span>
                                                                </div>
                                                            ))}
                                                            {!(scoreRec.Top3ScoringFactors) && (
                                                                <div className="no-factors">No scoring factors yet</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="name-mobile-text-wrapper">
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <h3 className="lead-name-text-v2">{lead.PersonName}</h3>
                                                <div className="related-to-row" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    {lead.LeadNo && <span className="lead-no-badge-modern-v2">{lead.LeadNo}</span>}
                                                </div>
                                            </div>
                                            <div className="header-contact-info-row" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '30px', marginTop: '12px' }}>
                                                {/* Phone */}
                                                {!isHiddenField('MobileNo') && (
                                                    <div className="info-item-box-v3" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <Phone size={14} color="#2563eb" fill="#eff6ff" />
                                                        <span
                                                            className="contact-link"
                                                            style={{ fontSize: '13px' }}
                                                            onClick={(e) => handleCallClick(e, lead.MobileNo)}
                                                        >
                                                            +91 {lead.MobileNo}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Email */}
                                                {!isHiddenField('EmailId') && (
                                                    <div className="info-item-box-v3" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <Mail size={14} color="#ea580c" />
                                                        <span style={{ fontSize: '13px' }}>{lead.EmailId}</span>
                                                    </div>
                                                )}

                                                {/* Location */}
                                                {!isHiddenField('City') && !isHiddenField('StateName') && (
                                                    <div className="info-item-box-v3" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <MapPin size={14} color="#059669" fill="#f0fdf4" />
                                                        <span style={{ fontSize: '13px' }}>{lead.CityName ? `${lead.CityName}, ${lead.StateName}` : lead.StateName}</span>
                                                    </div>
                                                )}

                                                {/* Company */}
                                                {!isHiddenField('CompanyName') && (
                                                    <div className="info-item-box-v3" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <Building2 size={14} color="#7c3aed" />
                                                        <span style={{ fontSize: '13px' }}>{lead.CompanyName}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Pipeline removed from here to fix layout */}

                                        </div>
                                    </div>
                                    <div className="last-updated-text-v2">
                                        <Calendar size={13} /> Last Updated : {lead.ModifiedOn}
                                    </div>

                                </div>
                                
                                {/* Pipeline Stages Visualization (Circles Stepper) */}
                                {(allPipelines.length > 0 || activePipeline) && (
                                    <div className="pipeline-stepper-container" style={{ padding: '0 25px 20px 25px', maxHeight: '180px', overflowY: 'auto' }}>
                                        {/* Fallback for single if allPipelines not populated */}
                                        {(allPipelines.length > 0 ? allPipelines : [{pipeline: activePipeline, stages: pipelineStages, statuses: mappingStatuses}]).map((pData, pIdx) => {
                                            if (pIdx > 0 && !showAllPipelines) return null;
                                            
                                            const pipeline = pData.pipeline;
                                            const stages = pData.stages;
                                            const statuses = pData.statuses;
                                            
                                            return (
                                                <div key={pipeline.PipeLineID || pIdx} className="mb-4 last:mb-0">
                                                    <div className="flex items-center gap-2 mb-4">
                                                        <GitBranch size={16} className="text-gray-600" />
                                                        <span className="font-bold text-gray-800 text-[13px]">{pipeline.PipelineName} Pipeline</span>
                                                    </div>

                                                    {/* Hide native scrollbar with CSS but keep overflowX auto */}
                                                    <div className="relative" style={{ overflowX: 'auto', paddingBottom: '10px', scrollbarWidth: 'none', msOverflowStyle: 'none' }} id={`pipeline-scroll-area-${pIdx}`}>
                                                        <style>{`#pipeline-scroll-area-${pIdx}::-webkit-scrollbar { display: none; }`}</style>
                                                        <div className="flex items-start" style={{ minWidth: 'max-content' }}>
                                                            {/* Connecting line */}
                                                            <div className="absolute top-[13px] left-[60px] right-[60px] h-[2px] bg-gray-200 z-0"></div>

                                                            {stages.map((stage, idx) => {
                                                                const currentStageId = parseInt(leadRec.StageID || leadRec.stageid || scoreRec.StageID || 0, 10);
                                                                const currentStageName = (leadRec.StageName || leadRec.stagename || scoreRec.StageName || "").toLowerCase();

                                                                const currentStageObj = stages.find(s => s.Id === currentStageId || s.Name.toLowerCase() === currentStageName);
                                                                const currentSeq = currentStageObj ? currentStageObj.Sequence : -1;

                                                                const isCompleted = stage.Sequence <= currentSeq;
                                                                const isActive = stage.Id === currentStageId || stage.Name.toLowerCase() === currentStageName;

                                                                const historyItem = pipelineHistory.find(h => (h.StageName === stage.Name || h.Name === stage.Name));
                                                                const mappedStatus = statuses[stage.Id];
                                                                const isMapped = mappedStatus && mappedStatus.Status === "Mapped";
                                                                const isDark = isMapped || isActive || isCompleted;

                                                                let displayDate = "";
                                                                if (mappedStatus) displayDate = mappedStatus.CreatedDate.split(' ')[0];
                                                                else if (historyItem) displayDate = new Date(historyItem.CreatedOn || historyItem.Date).toLocaleDateString('en-GB');

                                                                return (
                                                                    <div key={stage.Id} className="relative z-10 flex flex-col items-center" style={{ width: '120px' }}>
                                                                        {/* Circle */}
                                                                        <div 
                                                                            className={`w-7 h-7 rounded-full flex items-center justify-center border-2 mb-2 transition-colors duration-300 ${isDark ? 'text-white' : 'bg-white border-gray-300 text-transparent'}`}
                                                                            style={isDark ? { borderColor: '#0ea5e9', backgroundColor: '#0ea5e9', boxShadow: '0 0 0 4px rgba(14, 165, 233, 0.1)' } : {}}
                                                                        >
                                                                            {isDark && <Check size={16} strokeWidth={4} />}
                                                                        </div>
                                                                        {/* Name */}
                                                                        <span className={`text-[11px] text-center px-1 leading-tight ${isDark ? 'font-bold text-gray-800' : 'font-medium text-gray-500'}`}>
                                                                            {stage.Name}
                                                                        </span>
                                                                        {/* Date */}
                                                                        {displayDate && (
                                                                            <span className="text-[10px] text-gray-400 mt-0.5">{displayDate}</span>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        
                                        {allPipelines.length > 1 && (
                                            <div className="flex justify-center mt-1 border-t border-gray-100 pt-3 pb-1">
                                                <button 
                                                    onClick={() => setShowAllPipelines(!showAllPipelines)}
                                                    className="text-[11px] font-bold text-[#0ea5e9] hover:text-blue-700 flex items-center gap-1 transition-colors uppercase tracking-wider"
                                                >
                                                    {showAllPipelines ? (
                                                        <><ChevronUp size={14} /> Show Less Pipelines</>
                                                    ) : (
                                                        <><ChevronDown size={14} /> View {allPipelines.length - 1} More Pipeline{allPipelines.length > 2 ? 's' : ''}</>
                                                    )}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )}

                            </div>
                            <div className="basic-details-footer" style={{ borderTop: '1px solid #f1f5f9', padding: '12px 25px', display: 'flex', justifyContent: 'flex-end', background: '#fafafa' }}>
                                <span className="view-more-trigger" onClick={() => setIsFullDetailsOpen(true)} style={{ color: '#2563eb', fontWeight: '600', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    View More <ChevronRight size={14} />
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Custom Modal for Full Details (Basic + Other) */}
                    {isFullDetailsOpen && (
                        <div className="custom-details-modal-overlay">
                            <div className="custom-details-modal-container">
                                <div className="custom-modal-header">
                                    <div className="custom-modal-header-left">
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '12px' }}>
                                            <h3 className="custom-modal-title">Lead Information Details</h3>
                                            <button className="custom-modal-close-btn" onClick={() => setIsFullDetailsOpen(false)} style={{ margin: 0, position: 'static' }}>
                                                <X size={20} />
                                            </button>
                                        </div>
                                        <div className="modal-profile-header" style={{ width: '100%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                <div className="modal-avatar">
                                                    <div className="avatar-initials">{getInitials(lead.PersonName)}</div>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                    <div className="modal-lead-name-text">{lead.PersonName}</div>
                                                    {lead.LeadNo && (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span className="lead-no-badge-modern-v2">{lead.LeadNo}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="custom-modal-body">
                                    <div className="full-details-modal-content">
                                        <div className="modal-section-v2 basic-info">
                                            <h4 className="modal-inner-heading">Basic Information</h4>
                                            <div className="dynamic-details-grid-columns">
                                                {/* <div className="field-row-modern"><div className="field-label">Name :</div><div className="field-value">{lead.PersonName}</div></div> */}
                                                {!isHiddenField('MobileNo') && (
                                                    <div className="field-row-modern">
                                                        <div className="field-label">Mobile :</div>
                                                        <div className="field-value">
                                                            {lead.MobileNo}
                                                        </div>
                                                    </div>
                                                )}
                                                {!isHiddenField('EmailId') && <div className="field-row-modern"><div className="field-label">Email :</div><div className="field-value">{lead.EmailId}</div></div>}
                                                {!isHiddenField('CompanyName') && <div className="field-row-modern"><div className="field-label">Company :</div><div className="field-value">{lead.CompanyName}</div></div>}
                                                {!isHiddenField('City') && !isHiddenField('StateName') && <div className="field-row-modern"><div className="field-label">Location :</div><div className="field-value">{(lead.City && lead.City !== '') ? `${lead.City}, ${lead.StateName}` : lead.StateName}</div></div>}
                                            </div>
                                        </div>

                                        <div className="modal-divider-v2"></div>

                                        <div className="modal-section-v2 other-info">
                                            <h4 className="modal-inner-heading">Other Details</h4>
                                            <div className="dynamic-details-grid-columns">
                                                <div className="field-row-modern"><div className="field-label">Created On :</div><div className="field-value">{lead.CreatedOn}</div></div>
                                                {!isHiddenField('Source') && <div className="field-row-modern"><div className="field-label">Source :</div><div className="field-value">{lead.Source}</div></div>}
                                                <div className="field-row-modern"><div className="field-label">Modified On :</div><div className="field-value">{lead.ModifiedOn}</div></div>
                                                {!isHiddenField('Campaign') && <div className="field-row-modern"><div className="field-label">Campaign :</div><div className="field-value">{lead.Campaign}</div></div>}
                                                {!isHiddenField('Medium') && <div className="field-row-modern"><div className="field-label">Medium :</div><div className="field-value">{lead.Medium}</div></div>}
                                                <div className="field-row-modern"><div className="field-label">Address :</div><div className="field-value">{lead.Address}</div></div>
                                                <div className="field-row-modern"><div className="field-label">Created By :</div><div className="field-value">{lead.CreatedBy}</div></div>
                                                <div className="field-row-modern"><div className="field-label">Assigned To :</div><div className="field-value">{lead.AssignedTo}</div></div>
                                                <div className="field-row-modern"><div className="field-label">Follow Up Date :</div><div className="field-value">{lead.FollowupDate}</div></div>
                                                <div className="field-row-modern"><div className="field-label">Remark :</div><div className="field-value">{lead.Remark}</div></div>
                                                {lead.Groups !== '' && (
                                                    <div className="field-row-modern">
                                                        <div className="field-label">Groups :</div>
                                                        <div className="field-value" style={{ fontSize: '11px', lineHeight: '1.4' }}>{lead.Groups}</div>
                                                    </div>
                                                )}
                                                {/* Dynamic API Custom Fields Mapping */}
                                                {Array.isArray(enquiryDetailData) && enquiryDetailData.map((f, idx) => {
                                                    if (!f || !f.Text || typeof f.Text !== 'string') return null;
                                                    const parts = f.Text.split('|');
                                                    const displayValue = (parts[0] || '').replace(/^v/, '');
                                                    const label = parts[1] || 'Unknown';
                                                    const isSpecial = label === 'Education_diploma' || label === 'Demo_date';
                                                    const cleanLabel = label.replace(/_/g, ' ');
                                                    return (
                                                        <div key={idx} className="field-row-modern">
                                                            <div className="field-label">{cleanLabel} :</div>
                                                            <div className="field-value">
                                                                {isSpecial ? cleanLabel : (displayValue || '')}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Tabs Section */}
                    <div className="details-section shadow-sm flexible-tabs-section" style={{ border: 'none' }}>
                        <div className="tabs-container">
                            <Reorder.Group
                                axis="x"
                                values={tabOrder}
                                onReorder={(newOrder) => {
                                    setTabOrder(newOrder);
                                    const uid = LOGGED_USER_ID || 'user';
                                    localStorage.setItem(`LeadDetails_Tabs_${uid}_${isFollowupMode ? 'followup' : 'lead'}_${leadId}`, JSON.stringify(newOrder));
                                }}
                                className="tabs-list"
                            >
                                {tabOrder.map(tab => (
                                    <Reorder.Item
                                        key={tab}
                                        value={tab}
                                        className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
                                        onClick={() => {
                                            setActiveTab(tab);
                                            const uid = LOGGED_USER_ID || 'user';
                                            localStorage.setItem(`LeadDetails_ActiveTab_${uid}`, tab);
                                        }}
                                    >
                                        {tab}
                                    </Reorder.Item>
                                ))}
                            </Reorder.Group>
                        </div>
                        <div className="tabs-content" style={{ padding: '15px 0', background: '#f8fafc', flex: 1, display: 'flex', flexDirection: 'column', minHeight: '0' }}>
                            {activeTab === 'Activities' && (
                                <div className="activities-tab-content modern-tab-section shadow-sm">
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Lead Activities</div>
                                        <div className="activity-count">{activities.length} Events</div>
                                    </div>
                                    <div className="activities-timeline-v2" style={{ flex: 1, overflowY: 'auto', padding: '20px 0' }}>
                                        <div className="timeline-trail-v2"></div>
                                        {activities.length > 0 ? activities.map((act, i) => {
                                            const rawDate = act.EventDate || act.ActivityDate;
                                            const relativeTime = getRelativeTime(rawDate);
                                            const iconConfig = getActivityIconConfig(act);

                                            return (
                                                <div key={i} className={`timeline-item-v2 ${i % 2 === 0 ? 'item-left' : 'item-right'}`}>
                                                    <div className="timeline-center-node">
                                                        <span className="node-time-text">{relativeTime}</span>
                                                    </div>
                                                    <div className="timeline-branch"></div>
                                                    <div className="timeline-card-v2 shadow-sm">
                                                        <div className="timeline-card-header-v2">
                                                            <div className="title-with-icon">
                                                                <div className={`timeline-card-icon-v2 ${iconConfig.className}`}>
                                                                    {iconConfig.icon}
                                                                </div>
                                                                <h5 className="timeline-event-title-v2">
                                                                    {act.EventName || act.ActivityType || 'Activity'}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div className="timeline-card-body-v2">
                                                            <div className="timeline-desc-v2">
                                                                {renderActivityDescription(act.EventDescription || act.Description)}
                                                            </div>
                                                            <div className="timeline-timestamp-v2">
                                                                {formatDisplayDate(rawDate)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }) : (
                                            <div className="no-data-placeholder">
                                                <GitBranch size={48} />
                                                <p>No activity history available for this lead.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Followup Details' && isFollowupMode && (
                                <div className="followup-details-container modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Lead Followups</div>
                                        <div className="activity-count">{followupDetails.length} Records</div>
                                    </div>

                                    <div style={{ padding: '15px 20px', background: '#fff' }}>
                                        <div className="urgency-legend">
                                            <div className="legend-item">
                                                <span className="legend-dot overdue"></span>
                                                <span className="legend-text">Overdue / Today</span>
                                            </div>
                                            <div className="legend-item">
                                                <span className="legend-dot tomorrow"></span>
                                                <span className="legend-text">Tomorrow</span>
                                            </div>
                                            <div className="legend-item">
                                                <span className="legend-dot soon"></span>
                                                <span className="legend-text">In 7 Days</span>
                                            </div>
                                            <div className="legend-item">
                                                <span className="legend-dot future"></span>
                                                <span className="legend-text">Future</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="followup-table-wrapper" style={{ width: '100%', flex: 1 }}>
                                        <table className="followup-modern-table">
                                            <thead>
                                                <tr>
                                                    <th>FOLLOWUPSTATUS</th>
                                                    <th>NEXTSTATUSDATE</th>
                                                    <th>ISREASSIGN</th>
                                                    <th>REMARKS</th>
                                                    <th>PRODUCTS</th>
                                                    <th>AMOUNTPAID</th>
                                                    <th>ASSIGNEDTO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {followupDetails.length > 0 ? followupDetails.map((f, idx) => (
                                                    <tr key={idx}>
                                                        <td className="status-cell" style={{ fontWeight: '700', color: '#1e293b' }}>{f.FollowupStatus || 'N/A'}</td>
                                                        <td className={`date-cell ${getDateUrgencyClass(f.NextStatusDate)}`}>
                                                            {formatDisplayDate(f.NextStatusDate)}
                                                            <br />
                                                            <span className="time-sub-text">{f.NextStatusTime || ''}</span>
                                                        </td>
                                                        <td>{f.ReAssign || f.IsReassign || ''}</td>
                                                        <td>{f.Remarks || ''}</td>
                                                        <td>{f.Products || ''}</td>
                                                        <td>{f.AmountPaid || '0.00'}</td>
                                                        <td className="assigned-cell">{f.AssignedTo || ''}</td>
                                                    </tr>
                                                )) : (
                                                    <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>No followup details found</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Task' && (
                                <div className="task-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Lead Task History</div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', background: '#f1f5f9', padding: '2px 8px', borderRadius: '6px' }}>
                                                <span style={{ color: '#64748b', fontWeight: '600' }}>Sort:</span>
                                                <select 
                                                    value={taskSort} 
                                                    onChange={(e) => setTaskSort(e.target.value)}
                                                    style={{ border: 'none', background: 'none', fontSize: '12px', fontWeight: '700', color: '#1e293b', cursor: 'pointer', outline: 'none' }}
                                                >
                                                    <option value="newest">Newest First</option>
                                                    <option value="oldest">Oldest First</option>
                                                </select>
                                            </div>
                                            <div className="activity-count">{taskHistory.length} Tasks</div>
                                        </div>
                                    </div>
                                    <div className="history-list-wrapper" style={{ flex: 1, overflowY: 'auto', padding: '20px', background: '#f8fafc' }}>
                                        {taskHistory.length > 0 ? [...taskHistory].sort((a, b) => {
                                            const dA = new Date(a.CreatedOn || a.EntryDate || 0);
                                            const dB = new Date(b.CreatedOn || b.EntryDate || 0);
                                            return taskSort === 'newest' ? dB - dA : dA - dB;
                                        }).map((t, idx) => (
                                            <div key={idx} style={{ marginBottom: '35px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '5px' }}>
                                                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#475569' }}>Created By: {t.AddedByName || 'System'}</span>
                                                </div>
                                                <div className="history-modern-card" style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '4px', padding: '15px 20px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                                                    <div style={{ marginBottom: '15px' }}>
                                                        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '800', color: '#334155' }}>
                                                            {t.Subject || 'Task'} - {formatDisplayDate(t.EntryDate || t.CreatedOn)}
                                                        </h4>
                                                        <p style={{ margin: '8px 0 0 0', fontSize: '13px', color: '#475569', minHeight: '20px' }}>{t.Description || t.Remarks || ''}</p>
                                                    </div>

                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                            <div style={{ fontSize: '13px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '75px' }}>Due Date:</span>
                                                                <span style={{ color: '#475569' }}>{formatDisplayDate(t.NextStatusDate || t.DueDate)}</span>
                                                            </div>
                                                            <div style={{ fontSize: '13px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '75px' }}>Remarks :</span>
                                                                <span style={{ color: '#475569' }}>{t.Remarks || 'N/A'}</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                            <div style={{ fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '4px' }}>
                                                                {t.AssignedTo || t.AssignedToName || 'Unassigned'}
                                                            </div>
                                                            <div style={{ fontSize: '12px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '85px' }}>Collaborators:</span>
                                                                <span style={{ color: '#64748b' }}>{t.Collaborators || 'None'}</span>
                                                            </div>
                                                            <div style={{ fontSize: '12px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '85px' }}>Created On:</span>
                                                                <span style={{ color: '#64748b' }}>{formatDisplayDate(t.EntryDate || t.CreatedOn)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )) : (
                                            <div className="no-data-placeholder" style={{ textAlign: 'center', padding: '60px', background: '#fff', borderRadius: '12px', border: '1px dashed #e2e8f0' }}>
                                                <p style={{ color: '#94a3b8', margin: 0 }}>No task history found for this lead.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Appointment' && (
                                <div className="appointment-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Lead Appointment History</div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', background: '#f1f5f9', padding: '2px 8px', borderRadius: '6px' }}>
                                                <span style={{ color: '#64748b', fontWeight: '600' }}>Sort:</span>
                                                <select 
                                                    value={apptSort} 
                                                    onChange={(e) => setApptSort(e.target.value)}
                                                    style={{ border: 'none', background: 'none', fontSize: '12px', fontWeight: '700', color: '#1e293b', cursor: 'pointer', outline: 'none' }}
                                                >
                                                    <option value="newest">Newest First</option>
                                                    <option value="oldest">Oldest First</option>
                                                </select>
                                            </div>
                                            <div className="activity-count">{appointmentHistory.length} Records</div>
                                        </div>
                                    </div>
                                    <div className="history-list-wrapper" style={{ flex: 1, overflowY: 'auto', padding: '20px', background: '#f8fafc' }}>
                                        {appointmentHistory.length > 0 ? [...appointmentHistory].sort((a, b) => {
                                            const dA = new Date(a.CreatedOn || a.EntryDate || 0);
                                            const dB = new Date(b.CreatedOn || b.EntryDate || 0);
                                            return apptSort === 'newest' ? dB - dA : dA - dB;
                                        }).map((app, idx) => (
                                            <div key={idx} style={{ marginBottom: '35px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '5px' }}>
                                                    <span style={{ fontSize: '12px', fontWeight: '700', color: '#475569' }}>Created By: {app.AddedByName || 'System'}</span>
                                                </div>
                                                <div className="history-modern-card" style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '4px', padding: '15px 20px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                                                    <div style={{ marginBottom: '15px' }}>
                                                        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '800', color: '#334155' }}>
                                                            {app.Subject || 'Appointment'} - {formatDisplayDate(app.EntryDate || app.CreatedOn)}
                                                        </h4>
                                                        <p style={{ margin: '8px 0 0 0', fontSize: '13px', color: '#475569', minHeight: '20px' }}>{app.Description || app.Remarks || ''}</p>
                                                    </div>

                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                            <div style={{ fontSize: '13px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '85px' }}>Appt. Date:</span>
                                                                <span style={{ color: '#475569' }}>{formatDisplayDate(app.NextStatusDate || app.DueDate)}</span>
                                                            </div>
                                                            <div style={{ fontSize: '13px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '85px' }}>Remarks :</span>
                                                                <span style={{ color: '#475569' }}>{app.Remarks || 'N/A'}</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                            <div style={{ fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '4px' }}>
                                                                {app.AssignedTo || app.AssignedToName || 'Unassigned'}
                                                            </div>
                                                            <div style={{ fontSize: '12px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '85px' }}>Collaborators:</span>
                                                                <span style={{ color: '#64748b' }}>{app.Collaborators || 'None'}</span>
                                                            </div>
                                                            <div style={{ fontSize: '12px', display: 'flex', gap: '8px' }}>
                                                                <span style={{ color: '#475569', fontWeight: '800', minWidth: '85px' }}>Created On:</span>
                                                                <span style={{ color: '#64748b' }}>{formatDisplayDate(app.EntryDate || app.CreatedOn)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )) : (
                                            <div className="no-data-placeholder" style={{ textAlign: 'center', padding: '60px', background: '#fff', borderRadius: '12px', border: '1px dashed #e2e8f0' }}>
                                                <p style={{ color: '#94a3b8', margin: 0 }}>No appointment history found for this lead.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Chat Log' && (
                                <div className="chatlog-tab-content">
                                    <div className="chatlog-list-container">
                                        {chatLogs.length > 0 ? chatLogs.map((chat, idx) => (
                                            <div key={idx} className="note-card-item">
                                                <div className="note-text" style={{ whiteSpace: 'pre-wrap' }}>{chat.Message || chat.ChatLog || 'No message'}</div>
                                                <div className="note-date">{formatDisplayDate(chat.CreatedDate || chat.Date)}</div>
                                            </div>
                                        )) : (
                                            <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>No chat logs found</div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Webform' && (
                                <div className="webform-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Webform Submission History</div>
                                        <div className="activity-count">{webformData.length} Entries</div>
                                    </div>
                                    <div className="followup-table-wrapper" style={{ flex: 1, overflowY: 'auto' }}>
                                        <table className="followup-modern-table">
                                            <thead>
                                                <tr>
                                                    <th>Entry No</th>
                                                    <th>form Name</th>
                                                    <th>Entry Date</th>
                                                    <th>Remarks</th>
                                                    <th>Form Data</th>
                                                    <th>Agent</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {webformData.length > 0 ? webformData.map((wf, idx) => (
                                                    <tr key={idx}>
                                                        <td>{wf.EntryNo || idx + 1}</td>
                                                        <td style={{ fontWeight: '600' }}>
                                                            <span
                                                                className="contact-link"
                                                                onClick={() => {
                                                                    setSelectedWebformData(wf);
                                                                    setShowWebformModal(true);
                                                                }}
                                                                style={{ cursor: 'pointer', color: '#2563eb' }}
                                                            >
                                                                {wf.FormName || wf.formName || 'N/A'}
                                                            </span>
                                                        </td>
                                                        <td className="date-cell">{formatDisplayDate(wf.EntryDate || wf.entryDate)}</td>
                                                        <td>{wf.Remarks || wf.remarks || ''}</td>
                                                        <td style={{ fontSize: '11px', maxWidth: '250px' }}>
                                                            {(() => {
                                                                const rawData = wf.FormData || wf.formData || wf.DynimicAttr || wf.dynimicAttr || '';
                                                                if (!rawData) return '';
                                                                try {
                                                                    const parsed = typeof rawData === 'string' && (rawData.trim().startsWith('{') || rawData.trim().startsWith('['))
                                                                        ? JSON.parse(rawData)
                                                                        : null;

                                                                    if (parsed && typeof parsed === 'object') {
                                                                        return Object.entries(parsed)
                                                                            .filter(([k, v]) => v && v !== "" && k !== 'CountryCode')
                                                                            .map(([k, v]) => `${k}: ${v}`)
                                                                            .join(', ');
                                                                    }
                                                                    return rawData;
                                                                } catch (e) {
                                                                    return rawData;
                                                                }
                                                            })()}
                                                        </td>
                                                        <td>{wf.AgentName || wf.agent || 'N/A'}</td>
                                                    </tr>
                                                )) : (
                                                    <tr><td colSpan="6" style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>No webform entries found</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Pipeline' && (
                                <div className="pipeline-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title-group">
                                            <div className="header-title">Lead Pipeline</div>
                                            <div className="pipeline-legend">
                                                <div className="legend-item">
                                                    <span className="legend-pnt high"></span>
                                                    <span>High (&ge;80%)</span>
                                                </div>
                                                <div className="legend-item">
                                                    <span className="legend-pnt mid"></span>
                                                    <span>Mid (31-79%)</span>
                                                </div>
                                                <div className="legend-item">
                                                    <span className="legend-pnt low"></span>
                                                    <span>Low (&le;30%)</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="activity-count">{pipelineHistory.length} Pipelines</div>
                                    </div>

                                    <div className="activities-timeline-v2" style={{ padding: '40px 20px', flex: 1, overflowY: 'auto' }}>
                                        <div className="timeline-trail-v2"></div>
                                        {pipelineHistory.length > 0 ? pipelineHistory.map((ph, idx) => {
                                            const prob = parseFloat(ph.Probability) || 0;

                                            // Dynamic Color Logic (Strict adherence to your requirements)
                                            let strokeColor = '#ef4444'; // Red (Default < 30%)
                                            let glowColor = 'rgba(239, 68, 68, 0.2)';
                                            let pillBg = '#fee2e2';

                                            if (prob >= 80) {
                                                strokeColor = '#10b981'; // Green (>= 80%)
                                                glowColor = 'rgba(16, 185, 129, 0.2)';
                                                pillBg = '#dcfce7';
                                            } else if (prob > 30) {
                                                strokeColor = '#f59e0b'; // Amber (31-79%)
                                                glowColor = 'rgba(245, 158, 11, 0.2)';
                                                pillBg = '#fef3c7';
                                            }

                                            // SVG Math for Circle
                                            const radius = 30;
                                            const circumference = 2 * Math.PI * radius;
                                            const offset = circumference - (prob / 100) * circumference;

                                            return (
                                                <div key={idx} className={`timeline-item-v2 ${idx % 2 === 0 ? 'item-left' : 'item-right'}`}>
                                                    <div className="timeline-center-node">
                                                        <span className="node-time-text">{getRelativeTime(ph.CreatedDate)}</span>
                                                    </div>
                                                    <div className="timeline-branch"></div>
                                                    <div className="timeline-card-v2 shadow-sm">
                                                        <div className="pipeline-modern-card-inner">
                                                            <div className="card-left-visual">
                                                                <div className="circular-progress-wrapper" style={{ filter: `drop-shadow(0 0 6px ${glowColor})` }}>
                                                                    {/* Added rotation to start at 12 o'clock */}
                                                                    <svg width="80" height="80" viewBox="0 0 80 80" style={{ transform: 'rotate(-90deg)' }}>
                                                                        <circle
                                                                            cx="40" cy="40" r={radius}
                                                                            fill="none" stroke="#f1f5f9" strokeWidth="6"
                                                                        />
                                                                        <circle
                                                                            cx="40" cy="40" r={radius}
                                                                            fill="none" stroke={strokeColor} strokeWidth="6"
                                                                            strokeDasharray={circumference}
                                                                            strokeDashoffset={offset}
                                                                            strokeLinecap="round"
                                                                            style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }}
                                                                        />
                                                                    </svg>
                                                                    <div className="progress-text">
                                                                        <span className="prob-val" style={{ color: strokeColor }}>{prob}</span>
                                                                        <span className="percent-sign">%</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="card-right-details">
                                                                <div className="details-header">
                                                                    <div className="pipeline-main-info">
                                                                        <h4 className="pipeline-name-v2">{ph.PipelineName || 'N/A'}</h4>
                                                                        <div className="pipeline-stage-pill" style={{ background: pillBg, color: strokeColor }}>
                                                                            {ph.StageName || 'N/A'}
                                                                        </div>
                                                                    </div>
                                                                    <div className="pipeline-date-info">
                                                                        <Calendar size={13} />
                                                                        <span>{formatDisplayDate(ph.CreatedDate)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="details-body">
                                                                    {ph.Remarks && <p className="pipeline-remarks-v2">"{ph.Remarks}"</p>}
                                                                    <div className="pipeline-meta-footer">
                                                                        <div className="meta-item">
                                                                            <Calendar size={11} />
                                                                            <span>{formatDisplayDate(ph.CreatedDate)}</span>
                                                                        </div>
                                                                        <div className="meta-item">
                                                                            <Users size={11} />
                                                                            <span>{ph.DealOwnerByName || 'N/A'}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }) : (
                                            <div className="no-data-placeholder" style={{ textAlign: 'center', padding: '100px 0', color: '#94a3b8' }}>
                                                <GitBranch size={48} style={{ opacity: 0.2, marginBottom: '15px' }} />
                                                <p>No pipeline history found for this lead.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {(activeTab === 'WaChat Log' || activeTab === 'Whatsapp Chat Log') && (
                                <div className="wa-chat-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">WhatsApp Chat Logs</div>
                                        <div className="activity-count">{waChatLogs.length} Messages</div>
                                    </div>
                                    <div className="chat-log-list" style={{ width: '100%', padding: '20px', flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                        {waChatLogs.length > 0 ? waChatLogs.map((chat, idx) => (
                                            <div key={idx} className="chat-log-card modern-record-card">
                                                <div className="record-header">
                                                    <div className="record-type">
                                                        <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="wa" style={{ width: '18px' }} />
                                                        <span>WhatsApp Message</span>
                                                    </div>
                                                    <div className="record-date">{formatDisplayDate(chat.CreatedOn || chat.Date)}</div>
                                                </div>
                                                <div className="record-body">
                                                    <div className="message-text">{chat.Message || chat.Text || 'No message content'}</div>
                                                    {chat.FileName && (
                                                        <div className="attachment-pill" onClick={() => window.open(chat.FileLocation || chat.FilePath, '_blank')}>
                                                            <Paperclip size={14} />
                                                            <span>{chat.FileName}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="record-footer">
                                                    <div className="agent-info">
                                                        <Users size={14} />
                                                        <span>By: {chat.AgentName || chat.SenderName || 'Agent'}</span>
                                                    </div>
                                                    <div className={`direction-tag ${String(chat.Direction).toLowerCase()}`}>
                                                        {chat.Direction || 'inbound'}
                                                    </div>
                                                </div>
                                            </div>
                                        )) : (
                                            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
                                                <MessageSquare size={48} style={{ opacity: 0.2, marginBottom: '15px' }} />
                                                <p>No WhatsApp chat logs found</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Call Log' && (
                                <div className="call-log-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Lead Call Logs</div>
                                        <div className="activity-count">{callLogs.length} Records</div>
                                    </div>
                                    <div className="chat-log-list" style={{ width: '100%', padding: '20px', flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                        {callLogs.length > 0 ? callLogs.map((call, idx) => (
                                            <div key={idx} className="call-log-card modern-record-card" style={{ width: '100%', maxWidth: '100%' }}>
                                                <div className="record-header">
                                                    <div className="record-type">
                                                        {String(call.Direction).toLowerCase().includes('out') ? (
                                                            <PhoneCall size={18} style={{ color: '#3b82f6' }} />
                                                        ) : (
                                                            <Phone size={18} style={{ color: '#10b981' }} />
                                                        )}
                                                        <span>{call.Direction || 'Call Record'}</span>
                                                    </div>
                                                    <div className="record-date">{formatDisplayDate(call.Callstarttime)}</div>
                                                </div>
                                                <div className="record-body">
                                                    <div className="record-body-info">
                                                        <div className="info-item">
                                                            <strong>Number:</strong>
                                                            <span
                                                                className="contact-link"
                                                                style={{ marginLeft: '4px' }}
                                                                onClick={(e) => handleCallClick(e, call.Customernumber)}
                                                            >
                                                                {call.Customernumber || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="info-item">
                                                            <strong>Duration:</strong> {call.CallDuration || '0'}s
                                                        </div>
                                                        <div className="info-item">
                                                            <strong>Outcome:</strong> <span style={{ color: call.Outcome === 'Connected' ? '#10b981' : '#ef4444' }}>{call.Outcome || 'N/A'}</span>
                                                        </div>
                                                    </div>
                                                    <div className="call-log-media-section" style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #f1f5f9' }}>
                                                        <div className="recording-slot" style={{ width: '100%' }}>
                                                            <div style={{ fontSize: '10px', fontWeight: '800', color: '#94a3b8', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Recording</div>
                                                            <div className="audio-player-v3" style={{ background: '#f8fafc', padding: '6px 12px', borderRadius: '30px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center' }}>
                                                                <audio controls style={{ height: '32px', width: '100%' }}>
                                                                    <source src={call.Recordurl || ''} type="audio/mpeg" />
                                                                </audio>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="record-footer">
                                                    <div className="agent-info">
                                                        <Users size={14} />
                                                        <span>Agent: {call.AgentUserName || 'System'}</span>
                                                    </div>
                                                    <div className="direction-tag" style={{ background: '#f1f5f9', color: '#475569' }}>
                                                        {call.Status || 'Completed'}
                                                    </div>
                                                </div>
                                            </div>
                                        )) : (
                                            <div className="no-data-placeholder">
                                                <Phone size={48} />
                                                <p>No call logs found for this lead.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {activeTab === 'Meetings' && (
                                <div className="meetings-tab-content" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="meeting-subsection modern-tab-section shadow-sm" style={{ marginBottom: '20px', width: '100%' }}>
                                        <div className="activity-header-sticky">
                                            <div className="header-title">Upcoming Meetings</div>
                                        </div>
                                        <div className="followup-table-wrapper" style={{ width: '100%' }}>
                                            <table className="followup-modern-table">
                                                <thead>
                                                    <tr>
                                                        <th>SUBJECT</th>
                                                        <th>DATE</th>
                                                        <th>PLATFORM</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {upcomingMeetings.length > 0 ? upcomingMeetings.map((m, idx) => (
                                                        <tr key={idx}>
                                                            <td style={{ fontWeight: '600' }}>{m.MeetingSubject || m.Subject || 'N/A'}</td>
                                                            <td className="date-cell">{formatDisplayDate(m.MeetingDate || m.Date)} {m.MeetingTime || ''}</td>
                                                            <td>
                                                                {m.MeetingLink ? (
                                                                    <button className="attachment-pill" style={{ margin: 0 }} onClick={() => window.open(m.MeetingLink, '_blank')}>Join</button>
                                                                ) : 'N/A'}
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr><td colSpan="3" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>No upcoming meetings</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="meeting-subsection modern-tab-section shadow-sm" style={{ width: '100%' }}>
                                        <div className="activity-header-sticky">
                                            <div className="header-title">Past Meetings</div>
                                        </div>
                                        <div className="followup-table-wrapper" style={{ width: '100%' }}>
                                            <table className="followup-modern-table">
                                                <thead>
                                                    <tr>
                                                        <th>SUBJECT</th>
                                                        <th>DATE</th>
                                                        <th>RECORDING</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pastMeetings.length > 0 ? pastMeetings.map((m, idx) => (
                                                        <tr key={idx}>
                                                            <td style={{ fontWeight: '600' }}>{m.MeetingSubject || m.Subject || 'N/A'}</td>
                                                            <td className="date-cell">{formatDisplayDate(m.MeetingDate || m.Date)}</td>
                                                            <td>
                                                                {m.RecordingLink ? (
                                                                    <button className="attachment-pill" style={{ margin: 0 }} onClick={() => window.open(m.RecordingLink, '_blank')}>Play</button>
                                                                ) : 'N/A'}
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr><td colSpan="3" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>No past meetings</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Notes' && (
                                <div className="notes-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Lead Notes</div>
                                        <div className="activity-count">{notes.length} Records</div>
                                    </div>
                                    <div className="notes-list-container" style={{ padding: '20px', flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                        {notes.length > 0 ? notes.map((note, idx) => (
                                            <div key={idx} className="note-card-item">
                                                <div className="note-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                                    <div className="note-user-login" style={{ fontSize: '13px', fontWeight: '700', color: '#1e40af', background: '#eff6ff', padding: '2px 8px', borderRadius: '4px' }}>
                                                        {note.UserLogin || 'N/A'}
                                                    </div>
                                                    <button 
                                                        className="delete-note-btn" 
                                                        onClick={() => handleDeleteNote(note.NoteID)}
                                                        style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: '4px', borderRadius: '4px', transition: 'all 0.2s' }}
                                                        title="Delete Note"
                                                    >
                                                        <Trash2 size={16} />
                                                    </button>
                                                </div>
                                                <div className="note-text">{note.Notes}</div>
                                                <div className="note-date">{formatDisplayDate(note.CreatedDate)}</div>
                                            </div>
                                        )) : (
                                            <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>No notes found</div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {activeTab === 'Documents' && (
                                <div className="documents-tab-content modern-tab-section shadow-sm" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div className="activity-header-sticky">
                                        <div className="header-title">Lead Documents</div>
                                        <div className="activity-count">{documents.length} Files</div>
                                    </div>
                                    <div className="doc-table-wrapper" style={{ width: '100%', flex: 1 }}>
                                        <table className="followup-modern-table doc-modern-table">
                                            <thead>
                                                <tr>
                                                    <th>FILE NAME</th>
                                                    <th>TYPE</th>
                                                    <th>UPLOADED BY</th>
                                                    <th>DATE</th>
                                                    <th>ACTION</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documents.length > 0 ? documents.map((doc, idx) => {
                                                    // Remove extension from name for cleaner look
                                                    const cleanName = doc.DocumentName ? doc.DocumentName.replace(/\.[^/.]+$/, "") : 'N/A';

                                                    // Use the FileLocation directly if it's a full URL, otherwise fallback to constructive path
                                                    const fullUrl = doc.FileLocation || '#';

                                                    return (
                                                        <tr key={idx}>
                                                            <td style={{ color: '#1e293b', fontWeight: '700' }}>{cleanName}</td>
                                                            <td>{doc.FileType}</td>
                                                            <td style={{ fontWeight: '600', color: '#1e40af' }}>{doc.UserLogin || 'N/A'}</td>
                                                            <td>{formatDisplayDate(doc.UploadedDate)}</td>
                                                            <td>
                                                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                                    {fullUrl !== '#' && (
                                                                        <button 
                                                                            className="doc-open-btn" 
                                                                            onClick={() => window.open(fullUrl, '_blank')}
                                                                        >
                                                                            Open
                                                                        </button>
                                                                    )}
                                                                    <button 
                                                                        className="delete-note-btn" 
                                                                        onClick={() => handleDeleteDocument(doc.DocUpID)}
                                                                        style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: '4px', borderRadius: '4px', transition: 'all 0.2s' }}
                                                                        title="Delete Document"
                                                                    >
                                                                        <Trash2 size={16} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                }) : (
                                                    <tr><td colSpan="4" style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>No documents found</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                            {/* ... more tab content placeholders */}
                        </div>
                    </div>
                </div>

                {/* Sidebar - ENQUIRY ONLY */}
                {(module === 'enquiry' || !module) && (
                    <div className="lead-details-sidebar">
                        <button className="sidebar-action-btn"><GitBranch size={16} className="sidebar-icon" /> Add Or Merge Leads</button>
                        <button className="sidebar-action-btn"><MessageSquare size={16} className="sidebar-icon" /> SMS</button>
                        <button className="sidebar-action-btn"><Mail size={16} className="sidebar-icon" /> Mail</button>
                        <button className="sidebar-action-btn"><Mic size={16} className="sidebar-icon" /> Send Voice</button>
                        <button className="sidebar-action-btn"><PhoneCall size={16} className="sidebar-icon" /> Whatsapp</button>
                        <button className="sidebar-action-btn"><Users size={16} className="sidebar-icon" /> Create Meeting</button>
                        <button className="sidebar-action-btn"><UserPlus size={16} className="sidebar-icon" /> Physical Appointment</button>
                    </div>
                )}
            </div>

            <Enquiryoperations
                isOpen={isScheduleCallOpen}
                onClose={() => setIsScheduleCallOpen(false)}
                leadId={leadId}
            />

            {showCallWidget && callingLead && (
                <CallWidget
                    show={showCallWidget}
                    onClose={() => setShowCallWidget(false)}
                    toMobileNo={callingLead.MobileNo}
                    entityId={callingLead.LeadId || leadId}
                    entityName="Lead"
                    personName={callingLead.PersonName || lead.PersonName}
                    personImage={null}
                    triggerRect={callTriggerRect}
                />
            )}

            {/* Webform Details Modal */}
            {showWebformModal && selectedWebformData && (
                <div className="webform-modal-overlay" onClick={() => setShowWebformModal(false)}>
                    <div className="webform-modal-card" onClick={(e) => e.stopPropagation()}>
                        <div className="webform-modal-header">
                            <h3>{selectedWebformData.FormName || selectedWebformData.formName || 'Webform Details'}</h3>
                            <button className="close-btn-x" onClick={() => setShowWebformModal(false)}><X size={20} /></button>
                        </div>
                        <div className="webform-modal-body">
                            <div className="modal-actions-top">
                                <div className="action-icons-group">
                                    <button className="icon-btn-v2" title="Copy" onClick={() => handleCopyWebform(selectedWebformData)}><Copy size={18} /></button>
                                    <button className="icon-btn-v2" title="Print" onClick={() => handlePrintWebform(selectedWebformData)}><Printer size={18} /></button>
                                    <button className="icon-btn-v2" title="Download"><FileText size={18} /></button>
                                </div>
                            </div>
                            <div className="webform-fields-list">
                                {(() => {
                                    const rawData = selectedWebformData.FormData || selectedWebformData.formData || selectedWebformData.DynimicAttr || selectedWebformData.dynimicAttr || '';
                                    if (!rawData) return <div className="no-data">No data available</div>;
                                    try {
                                        const parsed = typeof rawData === 'string' && (rawData.trim().startsWith('{') || rawData.trim().startsWith('['))
                                            ? JSON.parse(rawData)
                                            : (typeof rawData === 'object' ? rawData : null);

                                        if (parsed && typeof parsed === 'object') {
                                            return Object.entries(parsed).map(([key, value], idx) => (
                                                <div key={idx} className="webform-field-row">
                                                    <span className="field-key">{key}:</span>
                                                    <span className="field-value">{value || '-'}</span>
                                                </div>
                                            ));
                                        }
                                        return <div className="raw-data-text">{rawData}</div>;
                                    } catch (e) {
                                        return <div className="raw-data-text">{rawData}</div>;
                                    }
                                })()}
                            </div>
                        </div>
                        <div className="webform-modal-footer">
                            <button className="close-footer-btn" onClick={() => setShowWebformModal(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
